<div class="search-container">
  <div class="mb-3" *ngIf="fb && fb.error">
    <lib-error [title]="getText()" [error]="getError()"></lib-error>
  </div>
  <div class="col-12 col-lg-8 px-0 filter-item">
    <lib-select-box 
      [permission]="this.permission"
      [idField]="'code'"
      [source]="countries" 
      [control]="form.controls.country" 
      [labelBlock]="true" 
      [idName]="'country'"
      [label]="'Country:' | translate">
    </lib-select-box>
  </div>
  <div class="col-12 px-0 filter-item">
    <lib-text-box *ngIf="country" 
      [permission]="this.permission" 
      [control]="searchControl" 
      [labelBlock]="true"
      [idName]="'include-component-parts'" 
      [label]="'Address Search:' | translate">
    </lib-text-box>
  </div>
  <div [ngClass]="{'table-style mb-4' : showPicker}">
    <ng-container *ngIf="showPicker">
      <div class="picker-option" *ngFor="let location of locations; let i = index" (click)="onSelectionChange(location, i)">
        {{ location.address }}
      </div>
      <div *ngIf="!locations.length && isBusy == false" class="no-match">
        {{'No matching addresses found' | translate}}
      </div>
    </ng-container>
    <div *ngIf="isBusy" class="col-12 text-center mb-4">
      <lib-loading 
        [status]="'text-secondary'" 
        [spinnerPosition]="true" 
        [size]="'md'">
      </lib-loading>
    </div>
  </div>
</div>